import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./features/shared/context/AuthContext";
import ProtectedRoute from "./features/shared/components/ProtectedRoute";
import ProtectedLayout from "./features/shared/components/ProtectedLayout";
import React from "react";
import Login from "./features/auth/pages/Login";
import Register from "./features/auth/pages/Register";
import Account from "./features/account/pages/Account";
import Patients from "./features/patients/pages/Patients";
import AccessDenied from "./features/auth/pages/AccessDenied";

import "material-icons/iconfont/material-icons.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/access-denied" element={<AccessDenied />} />

          <Route
            path="*"
            element={
              <ProtectedRoute>
                <ProtectedLayout />
              </ProtectedRoute>
            }
          >
            <Route path="patients" element={<Patients />} />
            <Route path="account" element={<Account />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
